import { useMutation } from '@tanstack/react-query';

import { VisitorFormSchemaValues } from 'src/features/visitor/utils/formSchema';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/visitors/active-stay/add-visitor/';
type MutationFnType = typeof mutationFn;
interface DTO extends VisitorFormSchemaValues {
    parkingId: string;
}

const mutationFn = ({ parkingId, ...data }: DTO): Promise<VisitorFormSchemaValues> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateVisitor };
